export { default } from './MyInvestmentsNav'
